import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { StoreAction } from 'store/actions';
import { LocationCollection } from './models/location';

@Injectable()
export class CbmLocationsApi {
    public static getCbmLocations(_xmStore: XmStore, http: HttpClient): Observable<LocationCollection> {
        return http.get('/xm/business/locations', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: LocationCollection) => LocationCollection.create<LocationCollection>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_SWITCH_LOCATIONS] = CbmLocationsApi.getCbmLocations;
